/*
 * @Descripttion: 权限控制
 * @Author: zenghua.wang
 * @Date: 2021-12-30 11:36:55
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-01-11 10:13:04
 */
import { getStore } from '@/framework/util/store'
import {
  isEmpty,
  getArrayByIntersection,
  getQueryArrByParams,
  setRowByRoute,
  getTextByAnalysis
} from '@/dragComponents/utils'

export default {
  computed: {
    userRoles() {
      return getStore({ name: 'userInfo' })?.subject?.roleList || []
    }
  },
  methods: {
    // data | data.option
    hasAuth(data) {
      if (isEmpty(data?.authType)) return true
      let isAuth = true
      let roleList = data.roleList || []
      let list = getArrayByIntersection(roleList, this.userRoles)
      switch (data.authType) {
        case 'black':
          isAuth = !!isEmpty(list)
          break
        case 'white':
          isAuth = !isEmpty(list)
          break
      }
      return isAuth
    },
    setRedirect(link) {
      let params = getQueryArrByParams(this.$route.query)
      let row = setRowByRoute(params)
      let url = getTextByAnalysis(link, row)
      if (isEmpty(url)) {
        this.noAuth = true
        return
      }
      setTimeout(() => {
        if (url.includes('http')) {
          window.open(url, '_blank')
        } else {
          this.$router.push(url)
        }
      }, 500)
    }
  }
}
